import { render, staticRenderFns } from "./需求项目商品详细_获嘉版本.vue?vue&type=template&id=ea8c7972&scoped=true"
import script from "./需求项目商品详细_获嘉版本.vue?vue&type=script&lang=js"
export * from "./需求项目商品详细_获嘉版本.vue?vue&type=script&lang=js"
import style0 from "./需求项目商品详细_获嘉版本.vue?vue&type=style&index=0&id=ea8c7972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8c7972",
  null
  
)

export default component.exports